import React from 'react'
import { Responsive, WidthProvider } from 'react-grid-layout'

import SeriesWidget from './SeriesWidget'
import TextWidget from './TextWidget'
import IndicatorWidget from './IndicatorWidget'

const ResponsiveReactGridLayout = WidthProvider(Responsive)

export const READ_ONLY_DASHBOARD_GRID_PROPS = {
  className: 'layout',
  rowHeight: 100,
  cols: { lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 },
  breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
  containerPadding: [0, 0],
  margin: [20, 20],
  compactType: null,
  preventCollision: true,
  isDraggable: false,
  isResizable: false,
  isDroppable: false,
}

const normalizeWidget = (widget, index) => ({
  ...widget,
  i: `public-${widget.type}-${widget.x}-${widget.y}-${index}`,
  w: widget.w ?? widget.width,
  h: widget.h ?? widget.height,
})

function DashboardPresentation({ widgets = [], backgroundColor }) {
  return (
    // Same inset padding + rounded corners as the private editor's widgets
    // area (DashboardDetailsScreen) — without it, a custom background color
    // filled the public page edge-to-edge with no visible "card" shape,
    // reading as barely-there instead of the same look the owner configured.
    <div className='px-3 pb-3 pt-4' style={{ backgroundColor: backgroundColor || '#F4F5F7', borderRadius: '8px' }}>
    <ResponsiveReactGridLayout {...READ_ONLY_DASHBOARD_GRID_PROPS} aria-label='Shared dashboard widgets'>
      {widgets.map(normalizeWidget).map(widget => (
        <div key={widget.i} data-grid={{ x: widget.x, y: widget.y, w: widget.w, h: widget.h }}>
          {widget.type === 'series' ? (
            <SeriesWidget editFlag={false} data={widget.content || {}} gridHeight={widget.h} />
          ) : widget.type === 'text' ? (
            <TextWidget editFlag={false} data={widget.content || {}} />
          ) : (
            <IndicatorWidget editFlag={false} data={widget.content || {}} />
          )}
        </div>
      ))}
    </ResponsiveReactGridLayout>
    </div>
  )
}

export default DashboardPresentation
